import { useState } from 'react';
import { useChartStore } from '@/store/chartStore';
import { PlusCircleIcon } from '@/components/icons';
import { SymbolSearchModal } from './SymbolSearchModal';
import type { SymbolInfo } from '@/types';
import { trackCompareAction } from '@/services/gtag';

// Palette of distinct line colours for up to 20 compare symbols
const COMPARE_COLORS = [
  '#f59e0b', '#3b82f6', '#ec4899', '#10b981',
  '#8b5cf6', '#f97316', '#06b6d4', '#84cc16',
  '#e11d48', '#0ea5e9', '#a855f7', '#14b8a6',
  '#fbbf24', '#6366f1', '#22c55e', '#ef4444',
  '#d946ef', '#64748b', '#fb923c', '#2dd4bf',
];

export const COMPARE_COLORS_EXPORT = COMPARE_COLORS;

export function CompareBar() {
  const symbol           = useChartStore((s) => s.symbol);
  const compareSymbols   = useChartStore((s) => s.compareSymbols);
  const addCompareSymbol = useChartStore((s) => s.addCompareSymbol);

  const [open, setOpen] = useState(false);

  const canAdd = compareSymbols.length < 20;
  const excluded = [symbol, ...compareSymbols];

  function handleSelect(s: SymbolInfo) {
    addCompareSymbol(s.symbol);
    trackCompareAction('add', s.symbol);
  }

  return (
    <div className="flex items-center gap-1 shrink-0">
      {/* + Compare button */}
      {canAdd && (
        <>
          {/* Mobile: circle + icon button */}
          <button
            onClick={() => setOpen(true)}
            className="md:hidden flex items-center justify-center p-1 text-muted hover:text-accent transition-colors shrink-0"
            title="Add comparison symbol"
          >
            <PlusCircleIcon size={22} />
          </button>
          {/* Desktop: small labeled button */}
          <button
            onClick={() => setOpen(true)}
            className="hidden md:flex items-center gap-1 h-6 px-1.5 rounded border border-border text-muted hover:text-text hover:border-accent transition-colors"
            title="Add comparison symbol"
          >
            <span className="text-lg leading-none">+</span>
            <span>Compare</span>
          </button>
        </>
      )}

      {open && (
        <SymbolSearchModal
          title="Add comparison"
          onClose={() => setOpen(false)}
          onSelect={handleSelect}
          excludeSymbols={excluded}
        />
      )}
    </div>
  );
}
